"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ACSlider = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var antd_1 = require("antd");
var react_1 = require("react");
var ACSlider = function (props) {
    var name = props.name, suffix = props.suffix, _a = props.value, value = _a === void 0 ? 0 : _a, _b = props.min, min = _b === void 0 ? 0 : _b, _c = props.max, max = _c === void 0 ? 0 : _c, steps = props.steps, _d = props.className, className = _d === void 0 ? '' : _d, _e = props.containerClassName, containerClassName = _e === void 0 ? '' : _e;
    var marks = (0, react_1.useMemo)(function () {
        var _a;
        var markLabel = function (value) { var _a; return (_a = "".concat(value).concat(suffix)) === null || _a === void 0 ? void 0 : _a.trim(); };
        if (!steps)
            return _a = {},
                _a[min] = markLabel(min),
                _a[max] = markLabel(max),
                _a;
        var res = {};
        for (var i = min; i <= max; i = i + steps) {
            res[i] = markLabel(i);
        }
        return res;
    }, [min, max, steps]);
    return ((0, jsx_runtime_1.jsx)("div", { className: containerClassName, children: (0, jsx_runtime_1.jsx)(antd_1.Slider, { step: steps, marks: marks, min: min, max: max, value: value, className: "apx-ui_slider ".concat(className), onChange: props.onChange && props.onChange }, name) }));
};
exports.ACSlider = ACSlider;
